import { Button, Input } from '@/components/ui'
import { useTranslate } from '@ur-solutions/react-hooks'
import React from 'react'
import type { EventQuestionNode } from '../types.graphql'

interface Props {
  question: EventQuestionNode
  value: string
  onChange(value: string): void
}

/** One of the event's questions, answered by the employee or on their behalf. */
export const EventQuestionField: React.FC<Props> = ({
  question,
  value,
  onChange,
}) => {
  const translations = useTranslate({
    required: 'events.question-required',
    yes: 'common.yes',
    no: 'common.no',
  })

  const label = (
    <span className="text-stone-700">
      {question.label}
      {question.required && (
        <span className="ml-1 text-xs text-stone-400">
          ({translations.required})
        </span>
      )}
    </span>
  )

  // A yes/no question is answered either way, so it takes two buttons rather
  // than a tick box that can only say yes.
  if (question.type === 'YES_NO')
    return (
      <div className="flex flex-wrap items-center gap-2 text-sm">
        {label}

        <div className="flex gap-1">
          <Button
            type="button"
            size="sm"
            variant={value === 'true' ? 'default' : 'outline'}
            onClick={() => onChange('true')}
          >
            {translations.yes}
          </Button>

          <Button
            type="button"
            size="sm"
            variant={value === 'false' ? 'default' : 'outline'}
            onClick={() => onChange('false')}
          >
            {translations.no}
          </Button>
        </div>
      </div>
    )

  return (
    <label className="flex flex-col gap-1 text-sm">
      {label}

      <Input
        value={value}
        type={question.type === 'NUMBER' ? 'number' : 'text'}
        className="max-w-72"
        onChange={onChange}
      />
    </label>
  )
}
